import { QueryClient, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

export const invalidateGuildBenefits = (queryClient: QueryClient) => {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ['guild'] }),
    queryClient.invalidateQueries({ queryKey: ['pageInfo'] }),
  ])
}

const useRefetchGuildBenefits = (enabled = true) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!enabled) return
    void invalidateGuildBenefits(queryClient)
  }, [enabled, queryClient])
}

export default useRefetchGuildBenefits
